function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwoStars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "90pt",
    height: "90pt",
    viewBox: "0 0 90 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 5.488281 78.839844 L 11.878906 62.550781 L 1.980469 47.789062 L 19.53125 49.140625 L 30.238281 35.460938 L 34.738281 52.558594 L 51.210938 58.769531 L 36.449219 68.039062 L 35.910156 85.679688 L 22.320312 74.25 Z M 5.488281 78.839844 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 54.179688 36.449219 L 58.859375 24.390625 L 51.570312 13.5 L 64.53125 14.488281 L 72.449219 4.320312 L 75.78125 17.011719 L 88.019531 21.601562 L 77.039062 28.441406 L 76.679688 41.488281 L 66.601562 33.03125 Z M 54.179688 36.449219 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwoStars);
export default __webpack_public_path__ + "static/media/two-stars.a53cd840862bb7c0c660748241cf1adc.svg";
export { ForwardRef as ReactComponent };